import React from 'react';
interface NumberFieldProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  suffix?: string;
  step?: number;
  min?: number;
}
export function NumberField({
  label,
  value,
  onChange,
  suffix,
  step = 1,
  min = 0
}: NumberFieldProps) {
  const id = React.useId();
  return <div data-id="element-85" data-mp="3bd64msgiwk08">
      <label htmlFor={id} className="block text-[11px] uppercase tracking-[0.14em] text-paper-dim" data-id="element-86" data-mp="3bcwgzbiyaoxp">
        {label}
      </label>
      <div className="mt-2 flex items-center gap-2 rounded-lg border border-line bg-ink-950 px-3 focus-within:border-paper-dim" data-id="element-87" data-mp="31frpqxa903a1">
        <input id={id} type="number" value={value} min={min} step={step} onChange={e => onChange(Number(e.target.value))} className="tnum w-full bg-transparent py-2.5 text-sm text-paper outline-none" data-id="element-88" data-mp="2np6450tetf8g" />
        {suffix ? <span className="shrink-0 text-xs text-paper-dim" data-id="element-89" data-mp="2ipjs2upbi518">{suffix}</span> : null}
      </div>
    </div>;
}